export const ENCRYPTED_ACCESS_CODE_KEY = "ECOA:ENCRYPTED_ACCESS_CODE";
